import { render, staticRenderFns } from "./CheckboxAnswer.vue?vue&type=template&id=42cbe074&scoped=true"
import script from "./CheckboxAnswer.vue?vue&type=script&lang=js"
export * from "./CheckboxAnswer.vue?vue&type=script&lang=js"
import style0 from "./CheckboxAnswer.vue?vue&type=style&index=0&id=42cbe074&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cbe074",
  null
  
)

export default component.exports